import { DatePicker } from '../../../atoms/search/DatePicker'
import { css } from '@emotion/react'
import { convertToDateString } from '@/lib/date'
import { colors } from 'plume-ui'
import { User } from '../../../../types'
import { useUser } from '../../../../contexts/AuthContext'

type Props = {
  shortName: string
  firstInterviewDate: Date
  onSelectFirstInterviewDateBlank: (shortName: string, user: User) => void
  onSelectFirstInterviewDate: (
    shortName: string,
    firstInterviewDate: string,
    user: User
  ) => void
}

export const CompanyFirstInterviewDateCalender: React.FC<Props> = ({
  shortName,
  firstInterviewDate,
  onSelectFirstInterviewDateBlank,
  onSelectFirstInterviewDate,
}) => {
  const user = useUser()
  const handleChangeDatepicker = (date: Date) => {
    if (firstInterviewDate) {
      onSelectFirstInterviewDate(shortName, convertToDateString(date), user)
    }
  }

  const handleDeleteDatepicker = () => {
    if (firstInterviewDate != null) {
      onSelectFirstInterviewDateBlank(shortName, user)
    }
  }

  const tenYearsFromNow = new Date(
    new Date().setFullYear(new Date().getFullYear() + 10)
  )
  const thirtyYearsAgo = new Date(
    new Date().setFullYear(new Date().getFullYear() - 30)
  )

  return (
    <div
      css={css`
        max-height: 300px;
      `}
    >
      <DatePicker
        className="first-interview-calender"
        selected={firstInterviewDate}
        css={css`
          .react-datepicker__day--today {
            border: 2px solid ${colors.cyan60} !important;
            color: black !important;
          }
        `}
        onChange={handleChangeDatepicker}
        onDelete={handleDeleteDatepicker}
        maxDate={tenYearsFromNow}
        minDate={thirtyYearsAgo}
      />
    </div>
  )
}
